import React from 'react';
import PropTypes from 'utils/propTypes';
import bn from 'utils/bemnames';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Typography from './Typography';
import withTranslation from '../hocs/withTranslation';

const bem = bn.create('page');

const Page = ({
  title,
  breadcrumbs,
  tag: Tag,
  className,
  children,
  headerRight,
  t,
  ...restProps
}) => {
  const classes = bem.b(className);

  return (
    <Tag className={classes} {...restProps}>
      <div className={bem.e('header')}>
        {title && typeof title === 'string' ? (
          <Typography type='h2' className={bem.e('title')}>
            {title}
          </Typography>
        ) : (
            title
          )}
        {breadcrumbs && (
          <Breadcrumb className={bem.e('breadcrumb')}>
            <BreadcrumbItem>{t(3)}</BreadcrumbItem>
            {breadcrumbs.length &&
              breadcrumbs.map(({ name, active, link }, index) => (
                <BreadcrumbItem key={index} active={active}>
                  {link ? <a href={link}>{name}</a> : name}
                </BreadcrumbItem>
              ))}
          </Breadcrumb>
        )}
        <div className={bem.e('right')}>
          {headerRight}
        </div>
      </div>
      {children}
    </Tag>
  );
};

Page.propTypes = {
  tag: PropTypes.component,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  children: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      active: PropTypes.bool,
    }),
  ),
};

Page.defaultProps = {
  tag: 'div',
  title: '',
};

export default withTranslation(Page);
